import { CSSProperties } from "react";

type MissingOwnBusinessNoticeProps = {
    keyword?: string | null;
    style?: CSSProperties;
};

export const MissingOwnBusinessNotice = ({ keyword, style }: MissingOwnBusinessNoticeProps) => {
    const keywordLabel = (keyword || '').trim();

    return (
        <div style={{
            padding: '12px 14px',
            borderRadius: 10,
            background: '#faf5ff',
            border: '1px solid #e9d5ff',
            flexShrink: 0,
            ...style,
        }}>
            <div style={{
                fontSize: 13,
                fontWeight: 700,
                color: '#5b21b6',
                lineHeight: 1.3,
                marginBottom: 4,
            }}>
                No eres relevante para búsquedas desde esta coordenada
            </div>
            <div style={{
                fontSize: 12,
                color: '#64748b',
                lineHeight: 1.45,
            }}>
                {keywordLabel ? (
                    <>Para la keyword <b style={{ color: '#475569' }}>«{keywordLabel}»</b> no eres relevante, es decir tu negocio no aparece en las búsquedas locales</>
                ) : (
                    <>No eres relevante para esta keyword, es decir tu negocio no aparece en las búsquedas locales</>
                )}
            </div>
        </div>
    );
};
